import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { MultiSelect } from 'legacy/lut/library/multiSelect'
import { FC, useCallback } from 'react'

import { MeasureController, useMeasureController } from 'core/analytics'
import { IPartnerContact } from 'partner360/features/contacts'
import { useCrudRoles } from 'partner360/hooks/useCrudRoles'

import styles from './ContactRolesSelector.module.scss'

interface IFormContactRolesProps {
  contact: IPartnerContact
  programType: ProgramTypes
  metrics: MeasureController
  onChange: (contact: IPartnerContact) => void
}

export const FormContactRoles: FC<IFormContactRolesProps> = ({
  contact,
  metrics,
  programType,
  onChange,
}) => {
  const measure = useMeasureController(metrics)
  const { crudRoles } = useCrudRoles({ programType, measure })

  const handleChangeRoles = useCallback(
    (value: string[]) => {
      const newRoles = value.filter((el) => el !== '').join(', ')
      onChange({
        ...contact,
        Roles: newRoles,
      })
    },
    [contact, onChange]
  )

  return (
    <MultiSelect
      classes={{
        controlClasses: {
          root: styles.input,
        },
      }}
      translation="jbp-partnercontactinfo-role"
      value={(contact.Roles || '').split(', ')}
      source={crudRoles}
      caption="value"
      onChange={handleChangeRoles}
    />
  )
}
